import styles from './RankingIcon.module.scss';

import type { FC, ReactNode } from 'react';

type Props = {
  rankingNumber: number;
  children?: ReactNode;
};

export const RankingIcon: FC<Props> = ({ rankingNumber }) => {
  switch (rankingNumber) {
    // eslint-disable-next-line no-magic-numbers
    case 1:
      return <strong className={styles['rank-first']}>{rankingNumber}</strong>;
    // eslint-disable-next-line no-magic-numbers
    case 2:
      return <strong className={styles['rank-second']}>{rankingNumber}</strong>;
    // eslint-disable-next-line no-magic-numbers
    case 3:
      return <strong className={styles['rank-third']}>{rankingNumber}</strong>;
    default:
      return <strong className={styles.rank}>{rankingNumber}</strong>;
  }
};
